<template>
  <div class="page page-mask">
    <svg v-if="!isIE11" class="page-mask--back" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 597 595.391 164" enable-background="new 0 597 595.391 164">
      <polygon fill="#FFFFFF" points="0,597 0,709.74 595.391,615.74 595.281,597 "/>
      <polygon fill="#FFFFFF" points="0,761 0,743.15 595.391,649.152 595.281,761 "/>
    </svg>
    <img v-else class="page-mask--back" src="/static/masks/mask-1.png"/>
  </div>
</template>

<script>
import IEDetector from '@/mixins/IEDetector';

export default {
  mixins: [IEDetector],
};
</script>



// WEBPACK FOOTER //
// src/components/Masks/Mask1.vue